export default {
  store_namespace: 'order',
  new_route_name: null,
  edit_route_name: null,
  auth_feature: 'order',
  detail_route_name: "AdminOrderDetail",
  csv_export_filename_prefix: 'commandes',
  hide_action_new_button: true,
  hide_action_pdf_button: true,
  hide_action_edit_button: true,
  hide_action_delete_button: true,
  export_csv: true,
  export_pdf: true,
  duplications: true,
  title_field: 'code',
  sort_by: 'code',
  sort_desc: true,
  fields: [
    {
      name: 'code',
      label: "Code",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      sortable: true,
    },
    {
      name: 'order_date',
      label: "Date",
      type: 'text',
      sortable: true,
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => context.$moment(value).utc().format("dddd DD MMMM YYYY")
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: false,
      extended_filter: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value || value == "0" ? context.$store.getters['order/getOrderStatusLabel'](value).text || null : null,
    },
    {
      name: 'type',
      label: "Type",
      type: 'select',
      inForm: true,
      required: true,
      sortable: true,
      inList: true,
      filterIn: false,
      extended_filter: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => {
        if (value == null) return null;
        let label = context.$store.getters['order/getOrderType'](value);
        return label == null? null : label.text;
      },
    },
    {
      name: 'tracking_number',
      label: "Numéro de tracking",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'tracking_url',
      label: "URL de tracking",
      type: 'link',
      inForm: true,
      required: true,
      inList: false,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'sh_number',
      label: "Numéro",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'comment',
      label: "Commentaire",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'created_by_user_id',
      label: "Créée par",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'created_by_user',
      label: "Créée par",
      inList: true,
      filterIn: true,
      formatter: (context, value, item) => item ? item.cbu_firstname + ' ' +  item.cbu_lastname : null
    },
    {
      name: 'created_by_user',
      label: "Créée par",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.firstname + ' ' +  value.lastname : null
    },
    {
      name: 'created_for_user_id',
      label: "Créée pour",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'created_for_user',
      label: "Créée pour",
      inList: true,
      filterIn: true,
      formatter: (context, value, item) => item ? item.cfu_firstname + ' ' +  item.cfu_lastname : null
    },
    {
      name: 'created_for_user',
      label: "Créée pour",
      type: 'select',
      inForm: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.firstname + ' ' +  value.lastname : null
    },
    {
      name: 'vehicle_id',
      label: "Véhicule",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'vehicle',
      label: "Véhicule",
      type: 'select',
      inForm: false,
      inList: false,
      filterIn: true,
      extended_filter: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.code : null
    },
  ],
  pdf_export_extra_lists: function (rawValues, values, context) {
    let lists = []
      let list = {
        label: "Detail commande",
        infos: [
          [
            "Produit",
            "Date d'envoi",
            "Quantité",
            "Quantité envoyée",
            "Quantité validée",
            "Quantité reçue"
          ],
          ...rawValues.lines.map(line =>[
            line.product.label,
            context.$moment(line.shipping_date).format("DD-MM-YYYY"),
            line.quantity,
            line.shipped_quantity,
            line.validated_quantity,
            line.received_quantity,
          ])
        ]};
      lists.push(list);
    return lists;
  },
}



// WEBPACK FOOTER //
// ./src/components/Order/config.js